import { useHotelFiltersContext } from "@/features/hotels/contexts/HotelFiltersContext";
import { useHotelSearchDataContext } from "@/features/hotels/contexts/HotelSearchDataContext";
import { useHotelSortContext } from "@/features/hotels/contexts/HotelSortContext";
import type { HotelSearchFormValues } from "@/features/hotels/utils/hotelsValidation";
import { usePreviousHotelSearchData } from "@/features/search/hooks/usePreviousSearchData";
import { HotelTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";

export const useHotelSearchForm = () => {
  const { resetSortValue } = useHotelSortContext();
  const { updateSearchData } = useHotelSearchDataContext();
  const { resetFilters } = useHotelFiltersContext();
  const { setPreviousSearchData } = usePreviousHotelSearchData();

  const handleSubmit = (values: HotelSearchFormValues) => {
    rudderAnalytics.track(HotelTrackingEvents.USER_SEARCHED_FOR_OFFERS, {
      destination: values.destination?.name,
      travel_date: values.dates.checkIn,
      return_date: values.dates.checkOut,
      rooms: values.rooms,
    });
    resetFilters();
    resetSortValue();
    setPreviousSearchData(values);
    updateSearchData(values);
  };

  return { handleSubmit };
};
